/**
 * Letter hero — reveal on load.
 *
 * @package HelloElementorChild
 */

import { initCamstReveal, teardownCamstReveal } from './camst-reveal.js';

export function initCamstLetterHero(scope) {
  var roots = [];

  if (!scope) {
    roots = Array.prototype.slice.call(document.querySelectorAll('[data-camst-letter-hero]'));
  } else if (scope.matches && scope.matches('[data-camst-letter-hero]')) {
    roots = [scope];
  } else {
    roots = Array.prototype.slice.call(scope.querySelectorAll('[data-camst-letter-hero]'));
  }

  roots.forEach(function (root) {
    if (root.dataset.camstLetterHeroInit === '1') {
      return;
    }

    root.dataset.camstLetterHeroInit = '1';
    initCamstReveal(root);
  });
}

export function teardownCamstLetterHero(scope) {
  if (!scope) {
    return;
  }

  var roots = scope.matches && scope.matches('[data-camst-letter-hero]')
    ? [scope]
    : Array.prototype.slice.call(scope.querySelectorAll('[data-camst-letter-hero]'));

  roots.forEach(function (root) {
    teardownCamstReveal(root);
    delete root.dataset.camstLetterHeroInit;
  });
}
